import React, { createContext, useState, useEffect } from "react";

const AuthContext = createContext();

// Decode JWT payload and check if expired — no backend call needed
const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

// Check whether stored user's membership has expired
const isMembershipExpired = (user) => {
  if (!user || !user.membershipPaid) return true;
  return new Date(user.membershipExpires) < new Date();
};

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoggedOut, setIsLoggedOut] = useState(true);
  const [userRole, setUserRole] = useState(null);
  const [isSubscriptionRequired, setisSubscriptionRequired] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const user = JSON.parse(localStorage.getItem("user"));
    if (token && user && !isTokenExpired(token)) {
      setIsLoggedIn(true);
      setIsLoggedOut(false);
      setisSubscriptionRequired(isMembershipExpired(user));
    } else {
      // Clear any stale / expired credentials
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      setIsLoggedIn(false);
      setIsLoggedOut(true);
      setUserRole(null);
    }

    // Periodically check if the token expires while the tab is open (every 60 s)
    const interval = setInterval(() => {
      const t = localStorage.getItem("token");
      if (t && isTokenExpired(t)) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        setIsLoggedIn(false);
        setIsLoggedOut(true);
        setUserRole(null);
        window.location.href = "/login";
      }
    }, 60_000);

    return () => clearInterval(interval);
  }, []);

  const login = (UserObj) => {
    localStorage.setItem("token", UserObj.token);
    localStorage.setItem("user", JSON.stringify(UserObj.user));
    setIsLoggedIn(true);
    setIsLoggedOut(false);
    setisSubscriptionRequired(isMembershipExpired(UserObj.user));
    checkAccountStatusAndRedirect(UserObj);
  };

  const checkAccountStatusAndRedirect = (UserObj) => {
    if (UserObj.user.accountStatus === "uncompleted") {
      window.location.href = "/completeAccount";
    } else {
      window.location.href = "/queue";
    }
  };

  const loggedUser = JSON.parse(localStorage.getItem("user"));

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setIsLoggedIn(false);
    setUserRole(null);
    setIsLoggedOut(true);
    setisSubscriptionRequired(null);
  };

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        isLoggedOut,
        userRole,
        login,
        logout,
        isSubscriptionRequired,
        loggedUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
